__turbopack_context__.v({
  "backButton": "styles-module-scss-module___UsSZW__backButton",
  "imageSearchBanner": "styles-module-scss-module___UsSZW__imageSearchBanner",
});
